import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"
import { useFormik } from "formik"


const LessonTaskForm = ({ open, onClose, onSave, data }) => {

    const { values, handleChange, handleSubmit } = useFormik({
        initialValues: data,
        onSubmit: onSave,
        enableReinitialize: true,
    })

    if (!data || !values) return null

    return <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">

        <DialogTitle>

        </DialogTitle>

        <DialogContent>
            <TextField
                id="name"
                name="name"
                label="Название задания"
                value={values.name}
                onChange={handleChange}
                fullWidth
            />
            <TextField
                id="task_text"
                name="task_text"
                label="Текст задания"
                value={values.task_text}
                onChange={handleChange}
                fullWidth
                multiline
                minRows={4}
                maxRows={8}
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={handleSubmit}>
                Сохранить
            </Button>
            <Button color="error" onClick={onClose}>
                Закрыть
            </Button>
        </DialogActions>
    </Dialog>
}

export default LessonTaskForm